import { ApplicationState } from '@/store';
import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, useHistory } from 'react-router-dom';
import CompletedPage from './Completed';
import FavoritesPage from './Favorites';
import MyCreationsPage from './MyCreations';
import './style.scss';

interface SectionRoute {
    component: ReactElement;
    path: string;
    title: string;
}

const MinePage: React.FC = () => {
    const history = useHistory();

    const [routes, setRoutes] = useState<SectionRoute[]>([]);
    const [selectedSectionTitle, setselectedSectionTitle] = useState<string>();

    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    useEffect(() => {
        const tmpRoutes: SectionRoute[] = [...routes];

        tmpRoutes.push({
            path: '/mine/favorites',
            title: 'FAVORITES',
            component: <FavoritesPage />,
        });

        tmpRoutes.push({
            path: '/mine/mycreations',
            title: 'MY_CREATIONS',
            component: <MyCreationsPage />,
        });
        tmpRoutes.push({
            path: '/mine/completed',
            title: 'COMPLETED',
            component: <CompletedPage />,
        });

        setRoutes(tmpRoutes);
    }, []);

    useEffect(() => {
        if (routes.length > 0) {
            const currentRoute: SectionRoute | undefined = routes.find((route: SectionRoute) => route.path === history.location.pathname);

            if (currentRoute) {
                setselectedSectionTitle(currentRoute.title);
            } else {
                setselectedSectionTitle(routes[0].title);
            }
        }
    }, [routes]);

    useEffect(() => {
        if (selectedSectionTitle) {
            const currentRoute: SectionRoute | undefined = routes.find((route: SectionRoute) => route.path === history.location.pathname);
            if (!currentRoute || currentRoute.title !== selectedSectionTitle) {
                history.push(routes.filter((route: SectionRoute) => route.title === selectedSectionTitle)[0].path);
            }
        }
    }, [selectedSectionTitle, history.location]);

    return (
        <div className="main">
            <header className="container mine-header">
                <ul className="nav modules">
                    {routes.map((route: SectionRoute, index: number) => {
                        return (
                            <li className="nav-item" key={index}>
                                <a
                                    className={`nav-link ${selectedSectionTitle === route.title ? 'active' : ''}`}
                                    onClick={() => setselectedSectionTitle(route.title)}
                                >
                                    {strings.MINE_PAGE[route.title]}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </header>
            <Switch>
                {routes.map((route: SectionRoute) => {
                    if (route.title === selectedSectionTitle) {
                        return (
                            <Route exact key={route.path} path={route.path}>
                                {route.component}
                            </Route>
                        );
                    }
                })}
            </Switch>
        </div>
    );
};
export default MinePage;
